import { render, staticRenderFns } from "./IseqBanner.vue?vue&type=template&id=49c0966e&scoped=true"
import script from "./IseqBanner.vue?vue&type=script&lang=js"
export * from "./IseqBanner.vue?vue&type=script&lang=js"
import style0 from "./IseqBanner.vue?vue&type=style&index=0&id=49c0966e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c0966e",
  null
  
)

export default component.exports